interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-2 text-sm font-medium transition-colors";

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="上一页"
        className={`${baseBtn} border-background-200 text-foreground-700 hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${baseBtn} ${
              item === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 text-foreground-700 hover:border-primary-500 hover:text-primary-400"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-foreground-500">
            …
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, page + 1))}
        disabled={page === total}
        aria-label="下一页"
        className={`${baseBtn} border-background-200 text-foreground-700 hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}